export default __webpack_public_path__ + "static/media/edit-pencil-primary.740d0f34.svg";